/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Paper } from '@material-ui/core'
import { AddShoppingCart, ShoppingCart, CurrencyRupee } from '@mui/icons-material'
import style from './index.module.css'
import Image from '../../Image/Image'
import { CURRENCY_ICON } from '../../../../utils/User/constants/Payment'
import { handleBuy } from '../../../../utils/User/helper/functions'

const Card = (props) => {
  const {
    pesticide: {
      id, name, image, company, price, discount, quantity, season, rating, detail, composition, categoryId, type,
    },
    handleAddToCart,
    isAdded,
    handleCartClick,
    history,
  } = props
  const { pesticide } = props
  // const base64String = btoa(String.fromCharCode(...new Uint8Array(image?.data)))
  // eslint-disable-next-line new-cap
  // const base64Strings = new Buffer.from(image.data).toString('base64')
  return (
    <>
      <div className='row mx-0'>
        <div className={ `card mt-1 ${ style.background }` }>
          <div
            className='product-1 align-items-center p-2 text-center'
            type='button'
            onClick={ () => handleCartClick(id) }
          >
            <Image
              src={ `${ process.env.REACT_APP_IMAGE_URL }${ image }` }
              alt='product'
              className={ style.image }
            />
            <h5>{ name }</h5>
            <div className='info'>
              <p className='text1'>{ composition }</p>
              <p className='text1'>{ quantity }</p>
            </div>
            <div className='cost text-dark'>
              <p>
                {CURRENCY_ICON.rupee}
                { price }
              </p>
            </div>
          </div>
          <div className={ style.addToCart }>
            <Button
              type='button'
              color='success'
              onClick={ handleAddToCart }
              className={ `mr-1 p-1 ${ isAdded && style.goToCart }` }
            >
              { isAdded ? <ShoppingCart /> : <AddShoppingCart /> }
            </Button>
            <Button
              type='button'
              className='p-1'
              color='success'
              onClick={ () => handleBuy(pesticide, history) }
            >
              {/* <i className='fa fa-truck' aria-hidden='true' /> */}
              {' '}
              Buy
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Card

Card.propTypes = {
  pesticide: PropTypes.objectOf.isRequired,
  handleAddToCart: PropTypes.func.isRequired,
  history: PropTypes.objectOf.isRequired,
  handleCartClick: PropTypes.func.isRequired,
  isAdded: PropTypes.bool.isRequired,
}
